import { render } from "./UserEditRole.vue?vue&type=template&id=6c0d3e75&scoped=true"
import script from "./UserEditRole.vue?vue&type=script&lang=js"
export * from "./UserEditRole.vue?vue&type=script&lang=js"

import "./UserEditRole.vue?vue&type=style&index=0&id=6c0d3e75&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c0d3e75"]])

export default __exports__